import React, { useEffect } from 'react'
import { useHistory } from 'react-router'
import { DistributorOrders } from '.'
import { getPharmacyInfoLocal } from '../../api'
import distributorApi from '../../api/distributor'
import { useAsync, useQuery } from '../../utils'
import { Header } from '../shared'
import DistributorInventory from './Inventory/DistributorInventories'

const DistributorDashboard = () => {
    const query = useQuery()
    const history = useHistory()
    const tab = query.get('tab')

    const { execute: getPharmacyOrderCount, value: count } = useAsync(distributorApi.getPharmacyOrderCount)

    useEffect(() => {
        const pharmacy = getPharmacyInfoLocal()

        getPharmacyOrderCount({
            and: [
                { mPharmacyId: pharmacy.pharmacyId },
            ],
            or: [
                { mStatus: "APPROVING" },
                { mStatus: "APPROVED" }
            ]
        })
    }, [])

    return <div className='admin-dashboard'>
        <Header title="Nhà phân phối" disableBackTo />
        <div id="admin-menu" className="distributor-menu">
            <div className="container">
                <div className="menu-tabs">
                    <a onClick={() => history.push(`/distributor-dashboard?tab=inventories`)} className={`${tab === "inventories" && "active"}`} >Sản phẩm</a>
                    <a onClick={() => history.push(`/distributor-dashboard?tab=orders`)} className={`${tab === "orders" && "active"}`} >Đơn hàng của bạn ({count})</a>
                </div>
            </div>
        </div>

        {tab === 'inventories' && <DistributorInventory />}
        {tab === 'orders' && <DistributorOrders />}
    </div>
}

export default DistributorDashboard